import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { MostLoanedDocumentsList } from "./MostLoanedDocumentsList";
import { OverdueDocumentsList } from "./OverdueDocumentsList";
import { TopBorrowersList } from "./TopBorrowersList";
import { BackOfficeRoutes } from "@routes/urls";
import { PickBorrowingList } from "./PickBorrowingList";
import DocumentUsage from "./DocumentUsage/DocumentUsage";

class Stats extends Component {
  render() {
    const { location } = this.props;
    const pathname = location.pathname;

    if (pathname === BackOfficeRoutes.stats.overdue) {
      return <OverdueDocumentsList />;
    } else if (pathname === BackOfficeRoutes.stats.mostLoaned) {
      return <MostLoanedDocumentsList />;
    } else if (pathname === BackOfficeRoutes.stats.topBorrowers) {
      return <TopBorrowersList />;
    } else if (pathname === BackOfficeRoutes.stats.documentUsage) {
      return <DocumentUsage />;
    } else if (pathname === BackOfficeRoutes.stats.home) {
      return <MostLoanedDocumentsList />;
    } else if (pathname === BackOfficeRoutes.stats.pickBorrowing) {
      return <PickBorrowingList />;
    } else {
      return <div>Stats component - no matching route</div>;
    }
  }
}

Stats.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Stats);
